import { useQuery } from '@apollo/client';
import { getCustomMetadataPropertyFilter } from 'app/domains/insights';
import { DefaultSearchFiltersDocument } from './DefaultSearchFilters.gql';
export function useGetCustomMetadataFilters() {
    const { data, error, loading } = useQuery(DefaultSearchFiltersDocument);
    const customProperties = (data === null || data === void 0 ? void 0 : data.documentMetadataProperties.filter((property) => {
        const isCustomProperty = Boolean(property.companyId);
        const isStringProperty = property.type === 'simpleText' || property.type === 'multiLineText';
        return isCustomProperty && !isStringProperty;
    }).map((property) => ({
        id: `metadataDocument${property.name}`,
        component: () => getCustomMetadataPropertyFilter({
            name: property.name,
            searchName: `metadataDocument${property.name}`,
            label: property.label,
            type: property.type,
            reference: property.reference,
            allowedValues: property.allowedValues,
        }),
        name: property.label,
    }))) || [];
    return {
        customProperties,
        loading,
        error,
    };
}
